<template>
  <div class="base_detail_modal">
     
    <Modal    
          v-model="modal"
          title="新增房屋" 
            :width="screenWidth*0.7"
          @on-cancel="cancel">
          <div class="base-modal"> 
            <VuePerfectScrollbar style=" display: block;height:600px ;overflow:auto;">
              <Alert type="warning" show-icon closable>温馨提示:未提交前请勿刷新页面，否则会丢失填入的数据和附件。</Alert>   
            <Form :model="house" ref="houseForm" :label-width="150" :rules="ruleValidate">
              <Alert>房屋概况</Alert>   
              <FormItem label="产权证地址" prop="cczdz">
                <Input v-model="house.cczdz" placeholder="请输入..."></Input>
              </FormItem>
              <FormItem label="不动产权号" prop="bdcqh">
                <Input v-model="house.bdcqh" placeholder="请输入..."></Input>
              </FormItem>
              <FormItem label="丘权号" prop="qqh">
                <Input v-model="house.qqh" placeholder="请输入..."></Input>
              </FormItem>
              <Row>
                <Col span="8">
                  <FormItem label="所在区" >
                      <Select v-model="house.szq" placeholder="请选择...">
                          <Option v-for="item in xzqList" :key="item.label" :value="item.label">{{item.label}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
                <Col span="8"> 
                  <FormItem label="出房指导价">
                    <Input v-model="house.cfzdj" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="8"> 
                  <FormItem label="物业费(元/月)">
                    <Input v-model="house.wyf" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
              </Row>
              <Row>
                <Col span="8">
                  <FormItem label="户型（室）" >
                      <Select v-model="house.hx_s" placeholder="请选择...">
                        <Option v-for="item in ['1室','2室','3室','4室','5室','6室','7室','8室','9室','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
                <Col span="8"> 
                  <FormItem label="户型（厅）">
                    <Select v-model="house.hx_t" placeholder="请选择...">
                        <Option v-for="item in ['1厅','2厅','3厅','4厅','5厅','6厅','7厅','8厅','9厅','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
                <Col span="8"> 
                  <FormItem label="户型（卫）">
                    <Select v-model="house.hx_w" placeholder="请选择...">
                        <Option v-for="item in ['1卫','2卫','3卫','4卫','5卫','6卫','7卫','8卫','9卫','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
              </Row>
              <FormItem label="面积（平米）">
                <Input v-model="house.mj" placeholder="请输入..."></Input>
              </FormItem>
              <Row>
                <Col span="12">
                  <FormItem label="楼层信息（第X层）" >
                    <Input v-model="house.lcxx" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="楼层信息（共X层）">
                    <Input v-model="house.lcxx_total" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="用途" >
                      <Select v-model="house.yt" placeholder="请选择...">
                        <Option v-for="item in ['住宅','公寓','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="朝向">
                    <Select v-model="house.cx" placeholder="请选择...">
                        <Option v-for="item in ['东','南','西','北','东南','东北','西南','西北','南北','东西']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="水卡" >
                    <Input v-model="house.sk" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="电卡">
                    <Input v-model="house.dk" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="电卡用户名" >
                    <Input v-model="house.dkyhm" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="气卡">
                    <Input v-model="house.qk" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="其他卡" >
                    <Input v-model="house.qtk" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                
              </Row>
              <FormItem label="备注">
                <Input v-model="house.bz" placeholder="请输入..."></Input>
              </FormItem>
              <Alert>产证信息</Alert>   
              
                <Upload :action="uploadUrl"  
                :headers="{ 'Authorization': 'Bearer ' +token }"
                accept=".jpg,.jpeg,.png,.pdf"
                :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'czImgList')" 
                :show-upload-list="true" 
                max-size="100*1024" >
              <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
            <Table border :columns="fjColums" :data="czImgList" :max-height="400">

              <template #img="{ row, index } " >
                  <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                    
                    <img style="width:200px;height:200px;" :src="row.img_base64" alt="">
                  </div>
                  <div v-else>仅支持图片预览</div>
                </template> 
                <template #action="{ row, index } " >
                  <div class="buttomGroup">
                    <div class="btn ck" @click="watchFile(row,'czImgList')">查看</div>
                    <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'czImgList')">下载</div> 
                    <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'czImgList')">删除</div>
                  </div>
                </template> 
              </Table>

              <Alert>身份证信息</Alert>   
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'sfzImgList')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增附件</Button>
                  </Upload>
                <Table border :columns="fjColums" :data="sfzImgList" :max-height="400"> 
                  <template #img="{ row, index } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="row.img_base64" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, index } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'sfzImgList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'sfzImgList')">下载</div> 
                        <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'sfzImgList')">删除</div>
                      </div>
                    </template> 
                  </Table>

              <Alert>房屋托管合同信息</Alert>   

              <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'fwtghtImgList')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增附件</Button>
                  </Upload>
                <Table border :columns="fjColums" :data="fwtghtImgList" :max-height="400"> 
                  <template #img="{ row, index } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="row.img_base64" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, index } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'fwtghtImgList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'fwtghtImgList')">下载</div> 
                        <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'fwtghtImgList')">删除</div>
                      </div>
                    </template> 
                  </Table>

              <Alert>房屋原貌</Alert>   
              <div style="width:100%;display: flex; gap:20px;">
                <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'fwImgList','客厅照片')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增客厅附件</Button>
                  </Upload>
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'fwImgList','厨房照片')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增厨房附件</Button>
                  </Upload>
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'fwImgList','卫生间照片')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增卫生间附件</Button>
                  </Upload>
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'fwImgList','卧室照片')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增卧室附件</Button>
                  </Upload>
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'fwImgList','其他照片')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增其他房间附件</Button>
                  </Upload>
                </div>

              
                  
                <Table border :columns="fjColums_v2" :data="fwImgList" :max-height="400"> 
                  <template #img="{ row, index } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="row.img_base64" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, index } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'fwImgList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'fwImgList')">下载</div> 
                        <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'fwImgList')">删除</div>
                      </div>
                    </template> 
                  </Table>

              <Alert>授权委托书</Alert>   

              <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_house(response, file, fileList, 'sqhtsImgList')" 
                    :show-upload-list="true" 
                    max-size="100*1024" >
                    <Button type="info" style="margin-left:20px;">新增附件</Button>
                  </Upload>
                <Table border :columns="fjColums" :data="sqhtsImgList" :max-height="400"> 
                  <template #img="{ row, index } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="row.img_base64" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, index } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'sqhtsImgList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'sqhtsImgList')">下载</div> 
                        <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'sqhtsImgList')">删除</div>
                      </div>
                    </template> 
                  </Table>

              <Alert>收房详情</Alert>   

              <Row>
                <Col span="12">
                  <FormItem label="产权人" >
                    <Input v-model="house.cqr" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="产权电话">
                    <Input v-model="house.cqdh" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>

              <Row>
                <Col span="12">
                  <FormItem label="产权人身份证号" >
                    <Input v-model="house.cqrsfz" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="受托代理人姓名">
                    <Input v-model="house.dllxm" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="委托人电话" >
                    <Input v-model="house.wtrdh" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="送达地址">
                    <Input v-model="house.sddz" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="收房渠道" >
                    <Select v-model="house.sfqd" placeholder="请选择...">
                        <Option v-for="item in ['中介','外网','老客户介绍','续签','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="收房费用">
                    <Input v-model="house.sffy" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="合同起始日" >
                     <DatePicker format="yyyy-MM-dd" @onChange="changeHtqsr" type="date" placeholder="请选择" style="width: 200px" />
                  </FormItem>
                </Col> 
                <Col span="12"> 
                  <FormItem label="合同到期日">
                    <DatePicker format="yyyy-MM-dd" @onChange="changeHtdqr" type="date" placeholder="请选择" style="width: 200px" />
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="8">
                  <FormItem label="第一年免租期（天）" >
                    <Input v-model="house.mzq_1" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="8"> 
                  <FormItem label="第二年免租期（天）">
                    <Input v-model="house.mzq_2" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
                <Col span="8">
                  <FormItem label="第三年免租期（天）" >
                    <Input v-model="house.mzq_3" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
              </Row>
              <Row> 
                <Col span="24"> 
                  <FormItem label="免租期备注">
                    <Input v-model="house.mzq_bz"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>
              <Row>
                <Col span="8">
                  <FormItem label="押金(元)" >
                    <Input v-model="house.yj" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="8"> 
                  <FormItem label="收房租金（元/月）">
                    <Input v-model="house.sfzj" type="number" placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
                <Col span="8">
                  <FormItem label="支付周期" >
                    <Select v-model="house.zfzq" placeholder="请选择...">
                        <Option v-for="item in [{label:'按月',value:1},{label:'按季',value:3},{label:'按半年',value:6},{label:'按年',value:12}]" :key="item.label" :value="item.label">{{item.label}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
              </Row>
              <Row> 
                <Col span="24"> 
                  <FormItem label="特别约定">
                    <Input v-model="house.tbyd"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
              </Row>
              <Row> 
                <Col span="12"> 
                  <FormItem label="支付户名">
                    <Input v-model="house.zfhm"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
                <Col span="12"> 
                  <FormItem label="银行卡号">
                    <Input v-model="house.yhkh"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
              </Row>
              <Row> 
                <Col span="8"> 
                  <FormItem label="开户行">
                    <Input v-model="house.khm"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col>  
                <Col span="8"> 
                  <FormItem label="交房日期">
                    <DatePicker format="yyyy-MM-dd" @onChange="changeJfrq" type="date" placeholder="请选择" style="width: 200px" />
                  </FormItem>
                </Col> 
                <Col span="8"> 
                  <FormItem label="是否开通燃气">
                    <Select v-model="house.ktrq" placeholder="请选择...">
                        <Option v-for="item in ['是','否']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
              </Row>
              <Alert show-icon type="warning">温馨提示：填写完成后请核对好相关信息和必填项！</Alert>

            </Form>
          </VuePerfectScrollbar>

          
          </div>
          <template #footer>
                <div></div>
                <Button type="primary" @click="handleSubmit('houseForm')">新增</Button>
            </template>

    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'; 
import {utilTools} from "@/utils/js/utilTools.js"
import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
export default {
  name:"base_detail_modal",
  comments:{VuePerfectScrollbar},
  props:{
    houseDetail:{
      type:Object,
      default:{},
    },
    photoKeyList:{
      type:Array,
      default:[]
    },
    otherKeyList:{
      type:Array,
      default:[]
    },
    keyList:{
      type:Array,
      default:[]
    }
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          //上传文件s
          uploadUrl:"/xjby/api/file/uploadHouseFiles",
          fjColums:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          fjColums_v2:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '房间', key: 'type_2', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          modal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant"],
          ruleValidate:{
                  cczdz: [
                        { required: true, message: '产权证地址不能为空', trigger: 'blur' }
                    ],
                  bdcqh: [
                        { required: true, message: '不动产权号不能为空', trigger: 'blur' }
                  ],
                  qqh: [
                        { required: true, message: '丘权号不能为空', trigger: 'blur' }
                  ],
                  },
          houseDetailShow:{},
          xzqList:[
            {label:"白下区",value:""}, {label:"鼓楼区",value:""}, {label:"建邺区",value:""},
            {label:"江宁区",value:""}, {label:"老下关",value:""}, {label:"浦口区",value:""},
            {label:"栖霞区",value:""}, {label:"秦淮区",value:""}, {label:"宣武区",value:""},
            {label:"雨花台区",value:""}, 
          ],
          house:{
            cczdz:"",//产权证地址
            bdcqh:"",//不动产权号
            qqh:"",//丘权号
            szq:"",//所在区
            cfzdj:0,//出房指导价
            wyf:"",//物业费(元/月)
            hx_s:"1室",//户型(室)
            hx_t:"1厅",//户型(厅)
            hx_w:"1卫",//户型(卫)
            mj:0.00,//面积(平米)
            lcxx:1,//楼层信息(第X层)
            lcxx_total:1,//楼层信息(共X层)
            yt:"住宅",//用途
            cx:"东",//朝向
            sk:"",//水卡
            dk:"",//电卡
            dkyhm:"",//电卡用户名
            qk:"",//气卡
            qtk:"",//其他卡
            bz:"",//备注
            cqr:"",//产权人
            cqdh:"",//产权电话
            cqrsfz:"",//产权人身份证号
            dllxm:"",//受托代理人姓名
            wtrdh:"",//委托人电话
            sddz:"",//送达地址
            sfqd:"中介",//收房渠道
            sffy:"",//收房费用
            htqsr:"",//合同起始日
            htdqr:"",//合同到期日
            mzq_1:"",//第一年免租期(天)
            mzq_2:"",//第二年免租期(天)
            mzq_3:"",//第三年免租期(天)
            mzq_bz:"",//免租期备注
            yj:"",//押金(元)
            sfzj:"",//收房租金(元/月)
            zfzq:"按季",//支付周期
            tbyd:"",//特别约定
            zfhm:"",//支付户名
            yhkh:"",//银行卡号
            khm:"",//开户行
            jfrq:"",//交房日期
            ktrq:"否",//是否开通燃气
          },
       
          czImgList:[],//产证信息
          sfzImgList:[],//身份证信息
          fwtghtImgList:[],//房屋托管合同信息
          fwImgList:[],//房屋原貌
          sqhtsImgList:[]//授权委托书
        }

    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
      
    },
    created(){  
      // this.$nextTick(()=>{
      //   this.houseDetail = this.cleanData(this.houseDetail, this.keyNotShow);
      // })


    },
   
    watch:{},
    methods:{
      // 预提交
      handleSubmit(name) {
       this.$refs[name].validate((valid) => {
         if (valid) {
            // this.$Message.success('Success!');
            let _this=this
            this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>请核实您输入的信息<br>`,
              onOk(){
                let param=_this.house
                param.czImgList=JSON.stringify(_this.czImgList)
                param.sfzImgList=JSON.stringify(_this.sfzImgList)
                param.fwtghtImgList=JSON.stringify(_this.fwtghtImgList)
                param.fwImgList=JSON.stringify(_this.fwImgList)
                param.sqhtsImgList=JSON.stringify(_this.sqhtsImgList)
                console.log("param==",param)

                zfglMethod_2_001.insertRecord(param).then((res)=>{
                  console.log("insert——res====",res)
                  if(res.data.insertRes!=0 && res.data.insertRes!=null){
                    _this.$Message.success("新增成功！")
                    _this.modal=false
                  }
                })


              }})
         } else {
             this.$Message.error('请核实输入的内容!');
         }
        })
      },
    

      // 房屋文件上传
      async uploadSuccess_house(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

        let obj = {
          save_name: response.data.saveName,
          save_url: response.data.savePath,
          show_name: response.data.showName,
          show_url: response.data.showPath,
          suffix: response.data.suffix,
          type_2:imageType?imageType:null,
          bz:"new_system",  
        };

        try {
          let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" + obj.show_url, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          console.log("obj==", obj);

          if (name === "czImgList") {
            this.czImgList.push(obj);
          }
          else if(name === "sfzImgList") {
            this.sfzImgList.push(obj);
          }
          else if(name === "fwtghtImgList") {
            this.fwtghtImgList.push(obj);
          }
          else if(name === "fwImgList") {
            this.fwImgList.push(obj);
          }
          else if(name === "sqhtsImgList") {
            this.sqhtsImgList.push(obj);
          }
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
      cleanData(obj, properties) { 
        console.log("obj===",obj)
        properties.forEach(property => {
          delete obj[property];
        }); 
        return obj;
      },
       // 在线预览文件
       watchFile(row,name) { 
        utilTools.downloadFromUrl("/xjby/view/" + row.show_url, row.show_name, "open",localStorage.getItem('token'))
      },
      // 下载附件
        downloadFile(row,name) {
          utilTools.downloadFromUrl("/xjby/view/" + row.show_url, row.show_name, "download",localStorage.getItem('token'))
      },
      // 删除遇上传的附件 
      deleteFileBefore(row,name) {
        let _this=this
        this.$Modal.confirm({
        title: '确认删除提醒',
        content: `<br> 删除后不可恢复<br>`,
        onOk(){
          if(name==="czImgList"){
            console.log("czImgList==",_this.czImgList)
            _this.czImgList=_this.czImgList.filter(item => item.save_name !== row.save_name)
          }
          else if(name==="sfzImgList"){
            _this.sfzImgList=_this.sfzImgList.filter(item => item.save_name !== row.save_name)
          }
          else if(name==="fwtghtImgList"){
            _this.fwtghtImgList=_this.fwtghtImgList.filter(item => item.save_name !== row.save_name)
          }
          else if(name==="fwImgList"){
            _this.fwImgList=_this.fwImgList.filter(item => item.save_name !== row.save_name)
          }
          else if(name==="sqhtsImgList"){
            _this.sqhtsImgList=_this.sqhtsImgList.filter(item => item.save_name !== row.save_name)
          }

        }
      })
      },
     
      
     
   
      cancel(){
        this.modal=false
      },
      changeHtqsr(date){
        this.house.htqsr=date
      },
      changeHtdqr(date){
        this.house.htdqr=date
      },
      changeJfrq(date){
        this.house.jfrq=date
      }
    }


}
</script>

  
  <style lang="scss" >
@import 'add_house_modal.scss'; 

.base-modal{
        width: 100%;
        height: 600px;
        padding: 20px;
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }

        }
        .buttomGroup{
                display: flex;
                width: 100%;
                text-align: center;
                align-items: center;
                justify-content: center;
                gap:20px;
                .btn{
                  width: 56px;
                  height: 34px;
                  border-radius: 4px;
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  line-height: 34px;
                  text-align: center;
                  cursor: pointer;
                }
                .ck{
                  background:rgba($color: #307EFF, $alpha: 0.1);
                  color: #307EFF;
                }
                .tg{
                  background:rgba($color: #0FD738, $alpha: 0.1);
                  color: #01B054 ;
                }
                .th{
                  background:rgba($color: #FF890A, $alpha: 0.1);
                  color: #FF890A;
                }
                .bj{
                  background:rgba($color: #307EFF, $alpha: 0.1);
                  color: #307EFF;
                }
                .tj{
                  background:rgba($color: #1CB9FF, $alpha: 0.1);
                  color: #0A9EE0;
                }
                .sc{
                  background:rgba($color: #EA1611, $alpha: 0.1);
                  color: #EA1611;
                }
              }
    }
  </style>